// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zotSp","header":"styles_header__JveU9","fullView":"styles_fullView__StV6k","shimmer":"styles_shimmer__GiiJk"};